import React, {FC} from 'react';

import QuestionCardRadio from '../../components/QuestionCardRadio';
import {MARITAL_OPTIONS} from '../../constants';

const StepMaritalStatus: FC = () => (
  <QuestionCardRadio field="maritalStatus" options={MARITAL_OPTIONS} />
);

export default StepMaritalStatus;
